import React from "react";
import Countdown, { zeroPad } from "react-countdown";
import { useHistory, useLocation } from "react-router-dom";

import { MyStopwatch, UserDialog, NavDraw } from "../../components";
import { ModuleContext } from "../../App";

import { Box, IconButton, Stack, Toolbar, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import BugReportIcon from "@mui/icons-material/BugReport";
import MuiAppBar from "@mui/material/AppBar";
import { styled } from "@mui/material/styles";

import logo from "../../assets/NSCC_logo.png";
import altlogo from "../../assets/SolverEDGE.svg";

import styles from "./styles.module.scss";

const drawerWidth = 290;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const SiteHeader = ({
  open,
  setOpen,
  timeLeft,
  timer,
  setBugOpen,
  setTimeUp,
  user,
  userRole,
}) => {
  const history = useHistory();
  const location = useLocation();

  const { moduleSettings } = React.useContext(ModuleContext);

  const toggleDrawer = () => setOpen(!open);

  const renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      setTimeUp(true);
      return <span>0:00</span>;
    } else {
      return (
        <span>
          {zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
      );
    }
  };

  return (
    <>
      <AppBar position="absolute" open={open}>
        <Toolbar sx={{ pr: "24px" }} className={styles.navWrap}>
          <>
            {(!moduleSettings.moduleType ||
              moduleSettings.moduleType === "Placement") &&
            userRole === "Student" ? null : (
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={toggleDrawer}
                sx={{
                  mr: "36px",
                  ...(open && { display: "none" }),
                }}
              >
                <MenuIcon />
              </IconButton>
            )}
            {user &&
            ((JSON.parse(user).student_region &&
              JSON.parse(user).student_region === 8) ||
              (JSON.parse(user).region_id &&
                JSON.parse(user).region_id === 8)) ? (
              <img
                src={altlogo}
                alt="SolverEdge Logo"
                onClick={() => history.push("/")}
                className={styles.logo}
                style={{
                  marginRight: "",
                  height: "60px",
                  maxWidth: "100px",
                  cursor: "pointer",
                }}
              />
            ) : (
              <img
                src={logo}
                alt="NSCC Logo"
                onClick={() => history.push("/")}
                style={{
                  // marginRight: "32px",
                  height: "60px",
                  maxWidth: "100px",
                  cursor: "pointer",
                }}
              />
            )}
            <Box component="div">
              <Typography
                variant="h6"
                sx={{ flexGrow: 1, ml: 5 }}
                className={styles.navbarTitle}
              >
                {moduleSettings.currentQuestion?.id &&
                (moduleSettings.moduleType === "Placement" ||
                  moduleSettings.moduleType === "Test" ||
                  moduleSettings.moduleType === "Assessment")
                  ? moduleSettings.selectedModule?.languageId === 1 ? `Question ${moduleSettings.currentQuestionNumber} of ${moduleSettings.selectedModule.totalQuestions}` : `問題 ${moduleSettings.currentQuestionNumber} of ${moduleSettings.selectedModule.totalQuestions}`
                  : ""}
                {!moduleSettings.currentQuestion &&
                  "SolverEdge Problem Solving Platform"}
              </Typography>
            </Box>
            {moduleSettings.currentQuestion?.id ? (
              <Typography variant="h6" component="div" sx={{ flexGrow: 1, ml: 5 }} className={styles.navbarTitle}>
                {moduleSettings.selectedModule?.languageId === 1 ? "Question" : "問題" } ID: {moduleSettings.currentQuestion?.originalQuestionId}
              </Typography>
            ) : null}
          </>
          {timer &&
            moduleSettings.moduleType !== "Training" &&
            moduleSettings.moduleType !== "Interactive" && (
              <Box
                sx={{
                  backgroundColor: "black",
                  mr: 8,
                  padding: 1,
                  pl: 2,
                  pr: 2,
                  width: "10vw",
                  textAlign: "center",
                }}
              >
                <Typography variant="h4" sx={{ color: "white" }}>
                  <Countdown
                    date={timeLeft}
                    renderer={renderer}
                    onComplete={() => {
                      if (
                        timer &&
                        moduleSettings?.moduleType !== "Training" &&
                        moduleSettings?.moduleType !== "Interactive"
                      )
                        setTimeUp(true);
                    }}
                  />
                </Typography>
              </Box>
            )}
          {timer &&
            (moduleSettings.moduleType === "Training" ||
              moduleSettings.moduleType === "Interactive") &&
            location.pathname !== "/instructions" && (
              <MyStopwatch timer={timer} />
            )}
          <Box className={styles.navIconWrap}>
            <IconButton
              className={styles.icon}
              onClick={() => setBugOpen(true)}
            >
              <BugReportIcon className={styles.icon} />
            </IconButton>
            <UserDialog className={styles.icon} />
          </Box>
        </Toolbar>
      </AppBar>
      {userRole === "Student" ? null : (
        <NavDraw
          toggleDrawer={toggleDrawer}
          userRole={userRole}
          open={open}
          moduleSettings={moduleSettings}
        />
      )}
    </>
  );
};

export default SiteHeader;
